(function () {
  'use strict';

  function initMellowCollectionFilters() {
    var root = document.querySelector('.mellow-coffee-collection');
    if (!root || root.getAttribute('data-mellow-filters-ready') === 'true') return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-mellow-filter]'));
    var products = Array.prototype.slice.call(root.querySelectorAll('[data-mellow-product]'));
    var grid = root.querySelector('[data-mellow-product-grid]');
    var count = root.querySelector('[data-mellow-visible-count]');
    var sort = root.querySelector('[data-mellow-sort]');
    var loadMore = root.querySelector('[data-mellow-load-more]');
    var initialVisibleLimit = 8;
    var activeFilter = 'all';
    var activeSort = 'manual';
    var expanded = false;

    if (!buttons.length || !products.length || !grid) return;
    root.setAttribute('data-mellow-filters-ready', 'true');

    function titleFor(product) {
      return (product.getAttribute('data-mellow-title') || '').toLocaleLowerCase('zh-Hant');
    }

    function priceFor(product) {
      return Number(product.getAttribute('data-mellow-price') || 0);
    }

    function originalIndexFor(product) {
      return Number(product.getAttribute('data-mellow-product-index') || 0);
    }

    function matchesFilter(product, filter) {
      var tokens = (product.getAttribute('data-mellow-filters') || '').split(/\s+/);
      return filter === 'all' || tokens.indexOf(filter) !== -1;
    }

    function sortProducts(items, sortValue) {
      var sorted = items.slice();
      sorted.sort(function (a, b) {
        if (sortValue === 'price-ascending') return priceFor(a) - priceFor(b);
        if (sortValue === 'price-descending') return priceFor(b) - priceFor(a);
        if (sortValue === 'title-ascending') return titleFor(a).localeCompare(titleFor(b), 'zh-Hant');
        if (sortValue === 'title-descending') return titleFor(b).localeCompare(titleFor(a), 'zh-Hant');
        return originalIndexFor(a) - originalIndexFor(b);
      });
      return sorted;
    }

    function applyCollectionState() {
      var sortedProducts = sortProducts(products.slice(), activeSort);
      var matchingProducts = sortedProducts.filter(function (product) {
        return matchesFilter(product, activeFilter);
      });

      sortedProducts.forEach(function (product) {
        grid.appendChild(product);
      });

      products.forEach(function (product) {
        var matchIndex = matchingProducts.indexOf(product);
        var isMatch = matchIndex !== -1;
        var show = isMatch && (activeFilter !== 'all' || expanded || matchIndex < initialVisibleLimit);
        product.hidden = !show;
        product.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show && window.lazySizes && window.lazySizes.loader) {
          Array.prototype.forEach.call(product.querySelectorAll('img.lazyload'), function (image) {
            window.lazySizes.loader.unveil(image);
          });
        }
      });

      buttons.forEach(function (button) {
        var active = button.getAttribute('data-mellow-filter') === activeFilter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (count) count.textContent = String(matchingProducts.length);
      if (loadMore) {
        var canExpand = activeFilter === 'all' && !expanded && matchingProducts.length > initialVisibleLimit;
        loadMore.hidden = !canExpand;
        loadMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = button.getAttribute('data-mellow-filter') || 'all';
        expanded = activeFilter !== 'all';
        applyCollectionState();
      });
    });

    if (sort) {
      sort.addEventListener('change', function () {
        activeSort = sort.value || 'manual';
        applyCollectionState();
      });
    }

    if (loadMore) {
      loadMore.addEventListener('click', function () {
        expanded = true;
        applyCollectionState();
      });
    }

    applyCollectionState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMellowCollectionFilters);
  } else {
    initMellowCollectionFilters();
  }

  document.addEventListener('shopify:section:load', initMellowCollectionFilters);
})();
